import { GridColDef } from '@mui/x-data-grid-pro';
import { CommissionRecord } from '@api/Trinium/Endpoints/Settlements/types';
import { negativeAmountClass } from '../gridStyles';

const currencyFormatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});

export const columns: GridColDef<CommissionRecord>[] = [
  { field: 'serviceCode', headerName: 'Service Code', width: 130 },
  { field: 'serviceDescription', headerName: 'Service Description', minWidth: 200, flex: 1 },
  { field: 'notes', headerName: 'Notes', minWidth: 260, flex: 1.5 },
  {
    field: 'amount',
    headerName: 'Amount',
    width: 120,
    type: 'number',
    valueFormatter: (value: number | undefined) => (value != null ? currencyFormatter.format(value) : ''),
    cellClassName: ({ row }) => (row.amount < 0 ? negativeAmountClass : '')
  }
];
